import React, { ReactNode } from "react";
import classNames from "classnames";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import styles from "./form-part.module.scss";

export type FormPartProps = {
  className?: string;
  forId: string;
  label?: string;
  tipText?: string;
  errorMsg?: string;
  children: ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

const FormPart = ({
  className = "",
  forId,
  label,
  tipText = "",
  errorMsg = "",
  children,
  ...props
}: FormPartProps) => {
  return (
    <div className={classNames(className, styles.content)} {...props}>
      {label && (
        <label htmlFor={forId}>
          <Paragraph size="xsmall">{label}</Paragraph>
        </label>
      )}
      {children}
      {tipText && (
        <Paragraph size="xsmall" weight="book" className={`${styles.tipText}`}>
          {tipText}
        </Paragraph>
      )}
      {errorMsg && (
        <Paragraph size="xsmall" weight="book" className={`${styles.errorMsg}`}>
          {errorMsg}
        </Paragraph>
      )}
    </div>
  );
};

export default FormPart;
